<div class="seccionTable">
  <a class="btnVolver" mat-flat-button routerLink="/seccion-panel/medico">
    <img src="assets/img/ico_volver2.png" class="iconBack" />
    <span class="nav-caption">Volver</span>
  </a>
  <mat-card class="cardTable mat-elevation-z4">
    <div class="topTitle">
      <mat-card class="titleSeccion">
        <span>Movimientos - {{ medicoNombre }}</span>
        <button
          mat-raised-button
          class="button"
          (click)="toggleFormulario()"
        >
          {{ mostrarFormulario ? "Cancelar" : "Agregar gasto" }}
        </button>
      </mat-card>
    </div>

    <!-- Formulario de gasto -->
    <div class="gastoForm" *ngIf="mostrarFormulario">
      <form [formGroup]="gastoForm" (ngSubmit)="guardarGasto()">
        <div class="formRow">
          <mat-form-field appearance="fill">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="pickerGasto" formControlName="fecha" />
            <mat-datepicker-toggle matSuffix [for]="pickerGasto"></mat-datepicker-toggle>
            <mat-datepicker #pickerGasto></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Monto ($)</mat-label>
            <input
              formControlName="monto"
              type="number"
              matInput
              min="0"
              step="0.01"
            />
            <mat-error *ngIf="gastoForm.get('monto').hasError('required')">
              El monto es requerido
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" style="flex: 2">
            <mat-label>Descripción</mat-label>
            <input formControlName="descripcion" type="text" matInput />
            <mat-error *ngIf="gastoForm.get('descripcion').hasError('required')">
              La descripción es requerida
            </mat-error>
          </mat-form-field>
          <button
            mat-raised-button
            class="buttonGuardar"
            type="submit"
          >
            {{ editandoId ? "Actualizar" : "Guardar" }}
          </button>
        </div>
      </form>
    </div>

    <!-- Filtros -->
    <div class="filtros" [formGroup]="filtrosForm">
      <mat-form-field appearance="fill">
        <mat-label>Fecha desde</mat-label>
        <input matInput [matDatepicker]="pickerDesde" formControlName="fechaDesde" />
        <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
        <mat-datepicker #pickerDesde></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Fecha hasta</mat-label>
        <input matInput [matDatepicker]="pickerHasta" formControlName="fechaHasta" />
        <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
        <mat-datepicker #pickerHasta></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="tipo">
          <mat-option value="">Todos</mat-option>
          <mat-option value="gasto">Gasto</mat-option>
          <mat-option value="turno">Turno</mat-option>
        </mat-select>
      </mat-form-field>

      <button class="buttonForm filtrarBtn" mat-raised-button (click)="filtrar()">
        <mat-icon>search</mat-icon> Filtrar
      </button>
      <button class="buttonForm limpiarBtn" mat-raised-button (click)="limpiarFiltros()">
        Limpiar
      </button>
    </div>

    <!-- Indicadores -->
    <div class="indicadores">
      <div class="indicador cobrado">
        <span class="indicador-label">Cobrado</span>
        <span class="indicador-valor">${{ totalCobrado | number : "1.2-2" }}</span>
      </div>
      <div class="indicador gastado">
        <span class="indicador-label">Gastado</span>
        <span class="indicador-valor">${{ totalGastado | number : "1.2-2" }}</span>
      </div>
      <div class="indicador saldo" [ngClass]="{ negativo: saldo < 0 }">
        <span class="indicador-label">Saldo</span>
        <span class="indicador-valor">${{ saldo | number : "1.2-2" }}</span>
      </div>
    </div>

    <!-- Acciones -->
    <div class="acciones">
      <button class="buttonForm exportarBtn" mat-raised-button (click)="exportarExcel()" [disabled]="movimientos?.length === 0">
        <mat-icon>download</mat-icon> Exportar Excel
      </button>
    </div>

    <!-- Tabla -->
    <table
      mat-table
      [dataSource]="movimientos"
      *ngIf="movimientos?.length > 0"
    >
      <ng-container matColumnDef="fecha_hora">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fecha_hora | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element">
          <span [ngClass]="element.tipo === 'gasto' ? 'tipo-gasto' : 'tipo-turno'">
            {{ element.tipo | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="monto">
        <th mat-header-cell *matHeaderCellDef>Monto</th>
        <td mat-cell *matCellDef="let element">
          ${{ element.monto | number : "1.2-2" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td mat-cell *matCellDef="let element">
          {{ element.descripcion }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            *ngIf="element.tipo === 'gasto'"
            mat-icon-button
            (click)="editarMovimiento(element)"
            matTooltip="Editar"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            *ngIf="element.tipo === 'gasto'"
            mat-icon-button
            color="warn"
            (click)="eliminarMovimiento(element.id)"
            matTooltip="Eliminar"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="sin-movimientos" *ngIf="movimientos?.length === 0">
      No hay movimientos para los filtros seleccionados
    </div>
  </mat-card>
</div>
